import {z} from 'zod'
import {Recommendation} from './Recommendation.js'
import {RecommendationId} from './RecommendationId.js'
import {RecommendationSourceType} from './RecommendationSourceType.js'
import {ConnectionId} from '../connection/index.js'
import {MergedRecommendationId} from './MergedRecommendationId.js'

export const MergedRecommendation = Recommendation.omit({id: true}).extend({
  id: MergedRecommendationId,
  recommendations: z.array(z.object({id: RecommendationId})),
  source: z.object({
    type: RecommendationSourceType,
    connectionId: ConnectionId,
  }),
})
export type MergedRecommendation = z.infer<typeof MergedRecommendation>
